import { useEffect, useRef } from "react";

export default function MemorableMoments() {
  const videoRef = useRef(null);
  const videoSectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const video = videoRef.current;
        if (!video) return;

        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.5 }
    );

    const section = videoSectionRef.current;
    if (section) observer.observe(section);

    return () => {
      if (section) observer.unobserve(section);
      observer.disconnect();
    };
  }, []);

  return (
    <section
      className="w-full bg-[#F5E9D8] text-[#1A1F2B] px-6 py-14 rounded-t-3xl"
      data-aos="fade-up"
    >
      <h2 className="text-3xl font-bold text-center mb-10">
        Memorable Moments
      </h2>

      <p className="text-lg text-center max-w-3xl mx-auto mb-12">
        Experience the heart of Moriah Church through worship services, fellowship,
        prayers, and community gatherings that bring people closer to God.
      </p>
         
           {/* 🖼️ IMAGE GRID */}
      <div
        className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto"
        data-aos="fade-up"
      >
        <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/memo-me1.jpeg" alt="Church worship moment" />
        <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/memo-me2.jpeg" alt="Prayer gathering at church" />
        <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/memo-me3.jpeg" alt="Sunday service fellowship" />
        <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/memo2.jpg" alt="Church community moment" />
        <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/memo-me5.jpeg" alt="Special church event" />
        <img loading="lazy" className="rounded-xl shadow-lg" src="/Images/memo-me6.jpeg" alt="Worship and praise session" />
      </div>

      {/* 🎥 2025 VIDEO SECTION */}
      <div
        ref={videoSectionRef}
        className="max-w-4xl mx-auto mb-14 text-center"
        data-aos="fade-up"
      >
        <p className="text-base md:text-lg mb-6 mt-6 leading-relaxed">
          As we reflect on the journey of 2025, we thank God for His faithfulness.
          Every prayer, every gathering, and every moment of worship strengthened
          our church family and deepened our walk in faith.
        </p>

        <video
          ref={videoRef}
          src="/Images/recap.mp4"
          muted
          playsInline
          controls
          preload="metadata"
          className="w-full rounded-2xl shadow-xl border-2 border-[#C9A86A]"
        />
      </div>

    
    </section>
  );
}
